module.exports = __webpack_public_path__ + "img/game-two.3b695218.png";